import {Pipe, PipeTransform} from '@angular/core';
import {AttributeItem} from 'src/app/users/_interfaces/users-admin';
import {ConfigService} from 'src/app/shared/services/multi-clients/config.service';
import {QuestionGroup} from '../interfaces/process-config.interface';

@Pipe({name: 'questionGroupAttributes'})
export class QuestionGroupAttributesPipe implements PipeTransform {
    
    private andOrQuestionGroupAttributes: boolean;
    constructor(private _configService: ConfigService) {
        this.andOrQuestionGroupAttributes = this._configService.settings.features.andOrQuestionGroupAttributes;
    }
    transform(groups: QuestionGroup[], attributes: any[]): QuestionGroup[] {
        const groupsFiltered = groups
            ? groups.filter(group => {
                if (!group.attributes || group.attributes.length === 0) return true;
                
                // Separate inclusion and exclusion attributes
                const inclusionAttributes = group.attributes.filter(ga => !ga.isExclusion);
                const exclusionAttributes = group.attributes.filter(ga => ga.isExclusion);
                
                // Check exclusion attributes first - if user has any exclusion attribute, hide the group
                const hasExclusionAttribute = exclusionAttributes.some(ga => 
                    attributes && attributes.some(a => (a.id === ga.attributeId || a.attributeId === ga.attributeId))
                );
                
                if (hasExclusionAttribute) return false;
                
                // If no exclusion attributes, check inclusion attributes (original logic)
                if (inclusionAttributes.length === 0) return true;
                
                return (inclusionAttributes.some(ga => attributes && attributes.some(a => (a.id === ga.attributeId || a.attributeId === ga.attributeId))) && this.andOrQuestionGroupAttributes) ||
                       (inclusionAttributes.every(ga => attributes && attributes.some(a => (a.id === ga.attributeId || a.attributeId === ga.attributeId))) && !this.andOrQuestionGroupAttributes);
            })
            : [];
        return groupsFiltered.filter(g => g.questions && g.questions.length > 0);
    }
}
